<template>
  <div class="section p-4">
    <nav class="navbar is-primary-invert p-2" role="navigation" aria-label="main navigation">
      <!-- Marca y botón hamburguesa -->
      <div class="navbar-brand">
        <a role="button" class="navbar-burger" :class="{ 'is-active': isActive }" @click="isActive = !isActive"
          aria-label="menu" aria-expanded="false">
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>

      <!-- Menú colapsable -->
      <div class="navbar-menu navmenu" :class="{ 'is-active': isActive }">
        <div class="navbar-start">
          <div class="tabs-with-buttons">
            <div class="buttons has-addons">
              <b-button :type="activeTab === 'subir_rec' ? 'is-primary' : 'is-light'"
                v-if="$store.getters.hasAnyRole(['empleador'])" @click="activeTab = 'subir_rec'">
                <i class="fas fa-upload fa-fw"></i>&nbsp;Subir Recibos
              </b-button>
              <b-button :type="activeTab === 'rec_pend' ? 'is-primary' : 'is-light'" @click="mostrarPendientesRec"
                v-if="$store.getters.hasAnyRole(['lyris', 'empleado'])"
                icon-left="file-signature">
                Firmar mis pendientes
              </b-button>
              <b-button :type="activeTab === 'org_pend' ? 'is-primary' : 'is-light'" @click="mostrarPendientesOrg"
                icon-left="industry"
                v-if="$store.getters.hasAnyRole(['lyris', 'empleador'])">
                Pendientes de la organización
              </b-button>

              <b-button :type="activeTab === 'hist' ? 'is-primary' : 'is-light'" @click="activeTab = 'hist'"
                icon-left="history" v-if="$store.getters.hasAnyRole(['lyris', 'empleado', 'empleador'])">
                Históricos
              </b-button>
            </div>
          </div>
        </div>

        <div class="navbar-end">
          <div class="tabs-with-buttons">
            <b-button v-if="activeTab != 'subir_rec' && activeTab != 'hist'" icon-left="sync" type="is-primary" @click="refresh">Recargar</b-button>
            <b-button v-if="selectedRecibos.length" icon-left="download" type="is-success"
              @click="download">&nbsp;Descargar {{selectedRecibos.length}} seleccionado{{selectedRecibos.length > 1 ? 's' : ''}}
            </b-button>
          </div>
        </div>
      </div>
    </nav>
    <!-- Contenido según la pestaña activa -->
     <div v-if="activeTab === 'subir_rec'" class="panel-inferior">
      <div class="column is-6">
        <Empleador @launch-firmador="launchFirmador" />
      </div>
    </div>
    <div v-if="activeTab === 'rec_pend'" class="panel-inferior">
      <ListadoPendientes @firmar-pendientes="firmarPendientes" ref="listado_pend" modo="firmar" />
    </div>
    <div v-else-if="activeTab === 'org_pend'" class="panel-inferior">
       <ListadoPendientes ref="listado_pend_org" modo="ver" />
    </div>
    <div v-else-if="activeTab === 'hist'" class="panel-inferior">
        <div class="columns">
          <div class="column is-3 is-3-tablet is-3-desktop">
            <Filtros @set-query="setQuery" />
          </div>
          <div class="column">
            <div class="box">
              <Listado ref="listado_hist" />
          </div>
        </div>
          <MultipleSidebar v-if="selectedRecibos.length" @download="download"/>
        </div>
    </div>
  </div>
</template>

<script>
import ListadoPendientes from '@/components/recibos/ListadoPendientes'
import Listado from '@/components/recibos/Listado'
import Filtros from '@/components/recibos/Filtros'
import MultipleSidebar from '@/components/recibos/MultipleSidebar'
import Empleador from '@/components/recibos/Empleador'
import ModalSubirRecibos from '@/components/recibos/ModalSubirRecibos'
import ModalLaunchFirmador from '@/components/utils/ModalLaunchFirmador'
import store from '@/store'

export default {
  components: {
    ListadoPendientes,
    Listado,
    Filtros,
    Empleador,
    MultipleSidebar
  },
  data () {
    return {
      selected: null,
      urlJnlp: null,
      frameSeleccionFirma: false,
      activeTab: '',
      isActive: false
    }
  },
  created: function () {
    this.activeTab = (store.getters.hasAnyRole(['empleado'])) ? 'rec_pend' : 'org_pend'
  },
  destroyed: function () {
    store.dispatch('recibos/unload')
  },
  methods: {
    setQuery: function (query) {
      this.$refs.listado_hist.setQuery(query)
      store.dispatch('recibos/unload')
    },
    refresh: function () {
      // Ver cual tab esta activado y enviar el refresh al que corresponda
      switch (this.activeTab) {
        case 'rec_pend':
          this.$refs.listado_pend.refresh()
          break
        case 'org_pend':
          this.$refs.listado_pend_org.refresh()
          break
        case 'hist': // aunque ahora no aparece el botón de refresh en esta pantalla
          this.$refs.listado_hist.refresh()
          store.dispatch('recibos/unload')
          break
        default: // subir_rec no tiene refresh
          break
      }
    },
    // launchFirmador es para subir recibos , un empleador
    launchFirmador: function (type, tipoRecibo) {
      if (type === 'firmador30') {
        const payload = {
          license: 'empleador',
          parametros: {
            tipoRecibo: tipoRecibo
          }
        }
        this.$store.dispatch('firmador/unload')
        this.$store.commit('firmador/setFirmadorSelected', 'signar_v3')
        this.$store.commit('firmador/setPayload', payload)
        this.$store.commit('firmador/setGoBack', { name: this.$route.name, params: this.$route.params })
        this.$buefy.modal.open({
          parent: this,
          canCancel: false,
          hasModalCard: true,
          component: ModalLaunchFirmador
        })
        // this.close()
      } else {
        const payload = {
          firmador: 'signar',
          opcion: 'documentos',
          lista: []
        }
        // this.$store.commit('firmador/cleanPila')
        // this.$store.commit('firmador/setGoBack')
        this.$http
          .post(
            'usuario/' + this.user.id + '/pila-documentos',
            payload
          )
          .then(res => {
            if (type === 'jnlp') {
              const urlJnlp = location.href.replace(
                window.location,
                '/jnlp/recibos?token=' + res.data.token
              )
              window.open(urlJnlp, '_self')
            } else if (type === 'firmador30') {
              const urlProtocol = `signarint://${res.data.token};${res.data.url};${res.data.usr};recibos`
              window.open(urlProtocol, '_self')
            } else {
              const urlProtocol = `signar://${res.data.token};${res.data.url};${res.data.usr};recibos`
              window.open(urlProtocol, '_self')
            }
          })
          .then(() => {
            this.$buefy.modal.open({
              parent: this,
              canCancel: false,
              hasModalCard: true,
              props: {
                type: type
              },
              component: ModalSubirRecibos,
              events: {
                reload: () => this.refresh()
              }
            })
          })
          .catch(err => {
            console.error('No se pudo actualizar la pila de documentos')
            console.error(err)
            this.$snackbar.open({
              message: 'Error. No se pudo comunicar con el servidor de archivos',
              type: 'is-warning',
              actionText: 'Recargar',
              indefinite: true,
              onAction: () => {
                location.reload()
              }
            })
          })
      }
    },
    // firmar recibos, un empleado
    firmarPendientes: function (typeFirmador, docIdsArray, conformidadArray) {
      var firmarPendientesPayload = null
      if (typeFirmador === 'signar_v3') {
        firmarPendientesPayload = {
          license: 'empleado',
          parametros: {
            docIds: docIdsArray,
            listaConformidad: conformidadArray
          }
        }
      } else {
        firmarPendientesPayload = {
          firmador: 'signar',
          opcion: 'recibos'
        }
      }
      this.$store.commit('firmador/cleanPila')
      this.$store.dispatch('firmador/unload')
      this.$store.commit('firmador/setFirmadorSelected', typeFirmador)
      this.$store.commit('firmador/setGoBack', { name: 'listarRecibos' })
      this.$store.commit('firmador/setPayload', firmarPendientesPayload)
      this.$buefy.modal.open({
        parent: this,
        canCancel: false,
        hasModalCard: true,
        component: ModalLaunchFirmador,
        events: {
          'close-modal': () => {
            this.$refs.listado_pend.refresh()
          }
        }
      })
    },
    download: function () {
      this.$buefy.snackbar.open({
        message:
          'Comprimiendo los archivos seleccionados para descargar, aguarde un momento',
        type: 'is-success'
      })
      const ids = this.$store.state.recibos.selected.map(r => r.id)
      this.$http
        .get('/documento/' + ids.join(',') + '/descarga?v=recibo')
        .then(response => {
          window.location.href = response.data.link
        })
        .catch(error => {
          console.error('Fail', error)
          this.$buefy.snackbar.open({
            message:
              'Error de conexión. Compruebe la conectividad con internet.',
            type: 'is-danger'
          })
        })
    },
    mostrarPendientes: function (tipoPendientes) {
      this.activeTab = tipoPendientes
      this.$nextTick(() => {
        this.refresh()
      })
    },
    mostrarPendientesRec: function () {
      this.mostrarPendientes('rec_pend')
    },
    mostrarPendientesOrg: function () {
      this.mostrarPendientes('org_pend')
    }
  },
  computed: {
    selectedRecibos: function () {
      return this.$store.state.recibos.selected
    },
    user: function () {
      return this.$store.getters.getUser
    }
  }
  // beforeRouteLeave (to, from, next) {
  // this.$store.commit('cleanSelectedRecibo')
  // this.$store.commit('setReciboService', {
  //   key: 'showFirmarMisRecibos',
  //   value: false
  // })
  // next()
  // }
}
</script>

<style lang="scss" scoped>
.custom-padding {
  padding-top: 14px;
  padding-bottom: 14px;
}

.tabs-with-buttons {
  .tabs-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    // agregá estos estilos para que los tabs crezcan
    .b-tabs {
      flex-grow: 1; // o flex: 1;
    }

    .actions {
      margin-left: 1rem; // opcional, para dar espacio
    }
  }
.b-tabs {
    background-color: white;
    margin-bottom: 0;

    .tab-item {
      padding: 1rem 1.5rem;
    }
  }
}

.buttons.has-addons .button {
  border: 1px solid #ccc !important;
  box-shadow: none !important;
}
.panel-inferior {
  padding: 12px 0px 0px 0px;
}
.navmenu {
   align-items: center;
}
</style>
